import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import { getSelectedGroupId } from 'modules/groups/selectors';
import { getState as getParent, getFilters } from 'modules/guidelines/selectors/ui/dashboard';
import { getLocale } from 'modules/i18n/selectors/data';
import { getDealerDefaultLanguage, getSelectedDealer } from 'selectors/dealerSelectors';

const getState = createSelector(getParent, state => state.group);

export const getGuidelineIds = createSelector(getState, state => state.ids);

export const isLoading = createSelector(getState, state => state.loading);

export const getApiError = createSelector(getState, state => state.error);

export const hasError = createSelector(getApiError, error => error !== null);

export const getPage = createSelector(getState, state => state.page);

export const getSort = createSelector(getState, state => state.sort);

export const getParams = createSelector(
  getFilters,
  getSelectedDealer,
  getSelectedGroupId,
  getPage,
  getSort,
  getDealerDefaultLanguage,
  getLocale,
  (filters, dealer: { groupId?: string }, groupId: MayBe<string>, { size }, sort, language: MayBe<string>, locale: MayBe<string>) => ({
    ...filters,
    groupId: groupId ?? dealer?.groupId,
    // The group list only contains guidelines not assigned to a dealer.
    notExist: 'dealerId',
    sort,
    size,
    language: groupId ? locale : language,
  })
);
